import {
  accountTypeInfo,
  accountTypeKeys,
} from "~/composables/account-type-details";

export function getInvestorSSNType() {
  return sessionStorage.getItem("investorSSNType");
}

export function getInvestorSSNValue() {
  return sessionStorage.getItem("investorSSNValue");
}

export function getInvestorCustomerId() {
  return sessionStorage.getItem("investorCustomerId");
}

export function getTenant() {
  return sessionStorage.getItem("ciamTenant");
}

export function isInvestorTaOnly() {
  return (
    sessionStorage.getItem(accountTypeInfo.taAccounts.hasAccountsKey) === "true"
  );
}

export function isInvestorTracOnly() {
  return (
    sessionStorage.getItem(accountTypeInfo.tracAccounts.hasAccountsKey) ===
    "true"
  );
}

export function getEnvironmentConfigFromHostApp() {
  return window.keaConfig?.Env;
}

export function getAccessToken(){
  return sessionStorage.getItem("investorAccessToken");
}

export function userHasAccounts() {
  let obj = accountTypeKeys.reduce((obj, key) => {
    obj[key] = JSON.parse(
      sessionStorage.getItem(accountTypeInfo[key].hasAccountsKey)
    );
    return obj;
  }, {});
  if (obj.taAccounts == false && obj.tracAccounts == false) {
    obj.taAccounts = true;
    obj.tracAccounts = true;
  }
  return obj;
}

export function isInvestorJustTrac() {
  return isInvestorTracOnly() && !isInvestorTaOnly();
}
